import { Icon, Popover, Position, Tag, Tooltip } from "@blueprintjs/core"
import { __, getID, sprintf } from "src/libs/utilities"
import { defaultSection } from "src/modules/pe-landing-module/data/defaults/defaultSection"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import FloatsSelectorList from "../FloatsSelectorList"
import MeatSelectorList from "../MeatSelectorList"
import createMeat from "../utils/createMeat"
import { showToast } from "src/libs/useful"
import updateSection from "../utils/updateSection"
import ClipboardSection from "./ClipboardSection"

/* Protopia Ecosystem component */
export interface ICurrentLayerPanelFormProps {
   
}
const CurrentLayerPanelForm = (props: ICurrentLayerPanelFormProps): JSX.Element => {
    const { 
        currentLanding, 
        selectedLayer,
        selectedElements, 
        selectedElementsType,   
        onPaste,
        copyData
    }	= useLandingStore((state: ILandingStore) => state)
    
    const section: ILandingSection = currentLanding.sections.find((section: ILandingSection) => section.id === selectedLayer)
    
    const setIsSectionEditOpen = ( sectionEditTab: string="main") => {
        useLandingStore.setState({ isSectionEdit: true, sectionEditTab, currentEditData: {...defaultSection(), ...section}, schema: "Section" })
    }
    const onDbl = () => {
        const i = currentLanding.sections.findIndex( (s: any) => s.id === selectedLayer )
        currentLanding.sections.splice( 
            i + 1, 
            0,
            { 
                ...section, 
                isHidden: false,
                id: getID( "section" ) 
            }
        )   
        useLandingStore.setState({ currentLanding, needUpdate: true })
    }
    const onRmv = () => { 
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.filter(( sec: HasId ) => selectedLayer !== sec.id )
        }        
        useLandingStore.setState({ currentLanding: newLanding, needUpdate: true })
    }
    const onNewMeat = (evt: MouseEvent, key: string, n: number = 0, ) => {
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((sec: ILandingSection) => {
                if( selectedLayer === sec.id ) {
                    return {
                        ...sec, 
                        data: [
                            ...sec.data,
                            createMeat( key, n, {} )
                        ]
                    } as ILandingSection
                }
                return sec
            })
        }        
        useLandingStore.setState({ currentLanding: newLanding, needUpdate: true })
    }
    const onNewSection = ( evt: MouseEvent, key: string, n: number,) => {
        const i = currentLanding.sections.findIndex( (s: any) => s.id === selectedLayer )
        const data = createMeat( key, n, {} )
        currentLanding.sections.splice( 
            i + 1, 
            0,
            {
                ...defaultSection(),
                title: {
                    text: data.defaultTitle
                },
                data: [ data ]
            } as ILandingSection
        )          
        useLandingStore.setState({ currentLanding: currentLanding, needUpdate: true })
    }

    const onPasteElements = () => {
        const elements: any = onPaste()
        const prevData = JSON.parse( JSON.stringify( section ))
        let data 
        const items =  elements.data.map((el: any) => ({...el, id: getID(el.type)}))
        
        console.log( items, elements.selectedElementsType )
        
        switch(elements.selectedElementsType) {
            case SELECT_TYPE.FLOAT:
                data = JSON.parse( JSON.stringify( 
                    {
                        ...section,
                        floats:  [
                            ...section.floats,
                            ...items
                        ]
                    }
                ))
                break
            case SELECT_TYPE.CONTENT:
            default:
                data = JSON.parse( JSON.stringify( 
                    {
                        ...section,
                        data:  [
                            ...section.data,
                            ...items
                        ]
                    }
                ))
        }
        updateSection(
            data,
            {
                data,
                prevData,
                type: HISTORY_TYPE.SECTION,
                title: "Paste group of elements to section"
            } as IHistoryStep
        )
        showToast({
            message: sprintf(__("Group of %s elements pasted to section"), selectedElements.length ),
            intent: "success"
        })
    }

    return !!section 
        ?
        <div className='landing-select-layer-panel w-100'>
            <div className="d-flex pt-1 pl-1 small w-100 justify-content-between">                
                <div className="d-flex">
                    <Tooltip
                        position={Position.TOP}
                        interactionKind="hover"
                        content={ <div className="small letter-spacing-1">{__("Section setting")}</div> }
                        portalClassName="z-index-120" 
                        intent="primary"
                        compact
                    >  
                        <Tag 
                            minimal 
                            size="medium" 
                            className="small text-light py-0 px-1 mb-1 mr-1 hover pointer"
                            onClick={() => setIsSectionEditOpen() } 
                            style={{height: 22}}
                        >  
                            <div className="d-flex align-items-center ">
                                <Icon icon="edit" size={ 9 } /> 
                            </div>
                        </Tag>
                    </Tooltip>
                    <Popover 
                        // position={Position.RIGHT}
                        interactionKind="click"
                        content={<MeatSelectorList onClick={onNewMeat} />} 
                        portalClassName="z-index-120" 
                    >
                        <Tooltip
                            position={Position.TOP}
                            interactionKind="hover"
                            content={ <div className="small letter-spacing-1">{__("Add Meat")}</div> } 
                            portalClassName="z-index-120" 
                            intent="primary" 
                            compact
                        >    
                            <Tag minimal size="medium" className="small text-light py-0 px-1 mb-1 mr-1 hover pointer" style={{height: 22}}>
                                <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                                    <Icon icon="plus" size={ 9 } />
                                    <img
                                        src={ "/assets/img/landing/meat.svg" }
                                        alt=""
                                        className="content-type-icon-light"
                                        height={ 10 }
                                    />
                                </div>
                            </Tag>
                        </Tooltip>
                    </Popover>
                    <Popover 
                        // position={Position.RIGHT}
                        interactionKind="click"
                        content={<FloatsSelectorList />} 
                        portalClassName="z-index-120" 
                    >
                        <Tooltip
                            position={Position.TOP}
                            interactionKind="hover"
                            content={ <div className="small letter-spacing-1">{__("Add Float")}</div> } 
                            portalClassName="z-index-120" 
                            intent="primary" 
                            compact
                        >    
                            <Tag minimal size="medium" className="small text-light py-0 px-1 mb-1 mr-1 hover pointer" style={{height: 22}}>
                                <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                                    <Icon icon="plus" size={ 9 } />
                                    <img
                                        src={ "/assets/img/landing/float.svg" }
                                        alt=""
                                        className="content-type-icon-light"
                                        height={ 10 }
                                    />
                                </div>
                            </Tag>   
                        </Tooltip>
                    </Popover>
                    <Popover 
                        // position={Position.RIGHT}
                        interactionKind="click"
                        content={
                            <div>
                                <MeatSelectorList onClick={onNewSection} />
                                <ClipboardSection section={section} /> 
                            </div>} 
                        portalClassName="z-index-120" 
                    >
                        <Tooltip
                            position={Position.TOP}
                            interactionKind="hover"
                            content={ <div className="small letter-spacing-1">{__("Append section after")}</div> }
                            portalClassName="z-index-120"
                            intent="primary"  
                            compact
                        >    
                            <Tag minimal size="medium" className="small text-light py-0 px-1 mb-1 mr-1 hover pointer " style={{height: 22}}>
                                <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                                    <Icon icon="plus" size={ 9 } />
                                    <img
                                        src={ "/assets/img/landing/layers.svg" }
                                        alt=""
                                        className="content-type-icon-light"
                                        height={ 10 }
                                    />
                                </div>
                            </Tag>
                        </Tooltip>
                    </Popover>
                    <div className="ml-3">
                        <Tooltip
                            position={Position.TOP}
                            interactionKind="hover"
                            content={ <div className="small letter-spacing-1">{__("Double section")}</div> }
                            portalClassName="z-index-120" 
                            intent="primary" 
                            compact
                        >
                            <Tag minimal size="medium" className="small text-light py-0 px-1 mb-1 mr-1 hover pointer " onClick={onDbl} style={{height: 22}}>
                                <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                                    <Icon icon="duplicate" size={ 9 } /> 
                                </div>
                            </Tag> 
                        </Tooltip>
                        {
                            copyData?.jsonData === "selectedElements" && !!copyData?.data.length 
                                ?
                                <Tooltip
                                    position={Position.TOP}
                                    interactionKind="hover"
                                    content={ <div className="small letter-spacing-1">{__("Paste %s elements")}</div> }
                                    portalClassName="z-index-120" 
                                    intent="primary" 
                                    compact
                                >
                                    <Tag minimal size="medium" className="small text-light py-0 px-1 mb-1 mr-1 hover pointer " onClick={ onPasteElements } style={{height: 22}}>
                                        <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                                            <Icon icon="clipboard" size={ 9 } /> 
                                        </div>
                                    </Tag> 
                                </Tooltip>
                                :
                                <></>
                        }
                    </div>                      
                </div>
                <div className="d-flex"> 
                    <Tooltip
                        position={Position.TOP}
                        interactionKind="hover"
                        content={ <div className="small letter-spacing-1">{__("Delete section")}</div> }
                        portalClassName="z-index-120" 
                        intent="primary" 
                        compact
                    >
                        <Tag minimal size="medium" className="small text-light py-0 px-1 mb-1 mr-1 hover pointer " onClick={onRmv} style={{height: 22}}>
                            <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                                <Icon icon="trash" size={ 9 } /> 
                            </div>
                        </Tag> 
                    </Tooltip>  
                </div>                   
            </div>
        </div>
        : 
        <></>
}
export default CurrentLayerPanelForm